import script from "./HentaiView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HentaiView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__